export default __webpack_public_path__ + "static/sv-logo-12cacc40a0b84a32ec58a4ddda83ddeb.png";